<template>
  <div class="mien w1400">
    <div class="mien-header font20">
      <span>当前位置：企业风采 > {{ firm[sliderTab].ts002 }}</span>
    </div>
    <div class="mien-cont">
      <el-row>
        <el-col :span="6">
          <div class="silder">
            <div :class="[i==sliderTab?'silder-item font20 bold':'silder-item font20']" v-for="(item,i) in firm"
                 :key='i' @click="childTab(i)">
              {{ item.ts002 }}
              <span class="botline" v-show='i==sliderTab'></span>
            </div>
          </div>
        </el-col>
        <el-col :span="18">
          <h1>{{ newInf.ty002 }}</h1>
          <div id="newsAbout"></div>
          <div class="noresource" v-if="!newInf.ty005">
            <img src="../../assets/hasNo.png" alt="">
          </div>
        </el-col>
      </el-row>
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {
      sliderTab: 0,
      firm: ['', '', ''],
      newInf: {}
    }
  },
  created() {
    this.parentId = this.$route.params.parentId;
    this.getchildMenu();
  },
  methods: {
    childTab(i) {
      this.sliderTab = i;
      this.getNewsInfo(this.firm[i].quoteid);
    },

    getchildMenu() {
      this.$axios.post('/api/webMenu/getById', {
        quoteid: this.parentId
      }).then(res => {
        let bufferArr = res.data.data;
        let con = bufferArr.children.sort((a,b)=>{
          return a.ts007 - b.ts007;
        });
        this.firm = con.filter(ele=>(ele.ts009>0));
        this.getNewsInfo(this.firm[0].quoteid);
      })
    },

    getNewsInfo(id) {
      this.$axios.post(`/api/news/list/${id}`, {}).then(res => {
        let data;
        try {
          this.newInf = res.data.data[0];
          data = res.data.data[0].ty005.replace(/192.168.81.240:8086/g, 'file.sywlfz.com')
        } catch (e) {
          this.newInf = {};
          data = '';
        }
        document.querySelector('#newsAbout').innerHTML = data;
        document.querySelectorAll('#newsAbout img').forEach(ele => {
          ele.style.display = 'block';
          ele.style.width = '90%';
          ele.style.margin = '0 auto';
        })
        document.querySelectorAll('#newsAbout video').forEach(ele => {
          ele.style.display = 'block';
          ele.style.width = '90%';
          ele.style.margin = '0 auto';
        })
        document.querySelectorAll("pre").forEach(ele => {
          ele.style.whiteSpace = 'break-spaces';
        })
      })
    }
  }
}
</script>

<style scoped>
.mien-header {
  display: flex;
  flex-wrap: nowrap;
  align-items: center;
  justify-content: space-between;
  box-sizing: border-box;
  width: 100%;
  height: 7rem;
  line-height: 7rem;
  padding: 0 2.7rem;
  background-color: #F6F5F5;
}

.inputbox {
  width: 21.6rem;
  line-height: normal;
}

.mien-cont {
  width: 100%;
}

.silder {
  min-height: 94rem;
  background-color: #F6EEEE;
}

.silder-item {
  position: relative;
  height: 8.4rem;
  line-height: 8.4rem;
  text-align: center;
  cursor: pointer;
  background-color: #f8f8f8;
  margin-bottom: 2px;
}

.botline {
  position: absolute;
  bottom: 0;
  left: 50%;
  transform: translateX(-50%);
  width: 10.5rem;
  height: 3px;
  background-color: #0083CE;
}

.noresource > img {
  display: block;
  width: 40rem;
  height: 40rem;
  margin: 20rem auto 0;
}
</style>



// WEBPACK FOOTER //
// src/components/page/mien.vue